import { browser } from '$app/environment';

class ThemeStore {
	mode = $state('automatic'); // 'dark' | 'light' | 'automatic'
	actualTheme = $state('light'); // The actual applied theme: 'dark' | 'light'

	constructor() {
		if (browser) {
			this.mode = this.getInitialMode();
			this.updateTheme();
			this.listenToSystemChanges();
		}
	}

	getInitialMode() {
		const saved = localStorage.getItem('themeMode');
		if (saved === 'dark' || saved === 'light' || saved === 'automatic') {
			return saved;
		}

		return 'automatic';
	}

	getSystemTheme() {
		if (!browser) return 'light';
		
		if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
			return 'dark';
		}
		return 'light';
	}

	updateTheme() {
		if (!browser) return;

		let themeToApply;
		
		if (this.mode === 'automatic') {
			themeToApply = this.getSystemTheme();
		} else {
			themeToApply = this.mode;
		}

		this.actualTheme = themeToApply;
		this.applyTheme(themeToApply);
	}

	applyTheme(theme) {
		if (!browser) return;

		if (theme === 'dark') {
			document.documentElement.classList.add('dark');
		} else {
			document.documentElement.classList.remove('dark');
		}
	}

	setMode(newMode) {
		if (!browser) return;
		
		if (newMode !== 'dark' && newMode !== 'light' && newMode !== 'automatic') {
			return;
		}

		this.mode = newMode;
		localStorage.setItem('themeMode', newMode);
		this.updateTheme();
	}

	listenToSystemChanges() {
		if (!browser) return;

		const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
		const handleChange = () => {
			if (this.mode === 'automatic') {
				this.updateTheme();
			}
		};

		mediaQuery.addEventListener('change', handleChange);
	}
}

export const themeStore = new ThemeStore();